import { useEffect, useState } from 'react'
import { customerData } from '../../../utilities/CustomerData'
import { apiURL } from '../../../utilities/URLs'
import BlueInkEmbed from '@blueink360/blueink-embed-js'
import { refreshAccessToken } from '../../../utilities/extensions'
import { useNavigate } from 'react-router-dom'

export function AdvancePaymentSpouseESign({ setNeedSpouseAffidavit }) {
  const navigate = useNavigate()
  const [eSignStep, setESignStep] = useState(0)
  const [embedUrl, setEmbedUrl] = useState('')

  const [spouseName, setSpouseName] = useState('')
  const [spouseLast4SSN, setSpouseLast4SSN] = useState('')
  const [gettingDoc, setGettingDoc] = useState(false)
  const [error, setError] = useState('')

  const embed = new BlueInkEmbed(process.env.REACT_APP_BLUEINK_PUBLIC_API_KEY)

  embed.on(BlueInkEmbed.EVENT.COMPLETE, () => {
    embed.unmount('#iframe-container') 
    setNeedSpouseAffidavit(false)
  })

  const handleGetEmbedURL = async () => {
    setGettingDoc(true)

    const form = new FormData()
    form.append('embedInfo', JSON.stringify({
      leadContact: customerData.customerLeadData.leadContact,
      advanceFundingApplication: customerData.customerAdvanceFunding,
      advanceFundingSpouseQuestionnaire: {
        spouseName: spouseName,
        spouseLast4SSN: spouseLast4SSN
      }
    }))

    const embedUrlResponse = await fetch(`${apiURL}/api/getSpouseAffidavitEmbedURL`, {
      method: 'POST',
      headers: {
        'Authorization': customerData.accessToken
      },
      body: form
    })
    const embedUrlData = await embedUrlResponse.json()
    setGettingDoc(false)

    if(embedUrlData.response.error) {
      if(embedUrlData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleGetEmbedURL() : navigate('/', { state: { expired: true } })
      } else if(embedUrlData.response.error === 'No IDme Attributes.')
          navigate('/resyncIDme') 
        else if(embedUrlData.response.error === 'Expired Documents')
          navigate('/syncNewDocuments', { state: { upload: true }})
        else if(embedUrlData.response.error === 'Spouse SSN Not Found.')
          setError('Spouse SSN not matching on transcript.')  
        else 
          console.error(embedUrlData.response.error)
    } else {
      setEmbedUrl(embedUrlData.response.embedUrl)
      setESignStep(eSignStep+1)
    }
  }

  useEffect(() => {
    if (eSignStep === 1 && embedUrl)
      embed.mount(embedUrl, '#iframe-container', { height: '1000px' })
  }, [eSignStep, embedUrl])

  return (
    <div className={`flex flex-col items-center lg:p-5 ${eSignStep === 0 || eSignStep === 2 ? 'lg:max-w-screen-lg w-11/12' : 'lg:w-screen w-11/12'}`}>
      {eSignStep === 0 ? (
        <div className='w-full flex-flex-col items-center'>
          <p className='text-2xl font-bold mb-4'>Spouse Affidavit</p>
          <div className='w-full flex flex-col gap-4'>
            <p>It looks like you filed as Married Filing Jointly in 2021, but only one spouse is claiming the Sick and Family Leave Credit. Before we can proceed, we need confirmation of this status.</p>
            <p>Please provide your spouse’s name and the last four digits of their Social Security Number, and sign an affidavit confirming that only one spouse is claiming the credit.</p>
            <div className='relative mb-4'>
              <p className='absolute text-sm bg-white left-3 top-[-5px] max-sm:text-[0.7rem] max-sm:top-[-4px]'>Spouse Name</p>
              <input
                type='text'
                name='firstName'
                placeholder='Spouse Name'
                value={spouseName}
                onChange={(e) => setSpouseName(e.target.value)}
                className='mt-1 p-3 w-full border rounded-md shadow-sm'
              />
            </div>
            <div className='relative mb-4'>
              <p className='absolute text-sm bg-white left-3 top-[-5px] max-sm:text-[0.7rem] max-sm:top-[-4px]'>Spouse Last 4 SSN</p>
              <input
                type='text'
                name='spouseSSN'
                maxLength={4}
                placeholder='XXXX'
                value={spouseLast4SSN}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/\D/g, '')
                  setSpouseLast4SSN(numericValue)
                }}
                className='mt-1 p-3 w-full border rounded-md shadow-sm'
              />
            </div>
            <button
              disabled={!spouseLast4SSN || spouseLast4SSN.length < 4 || !spouseName || gettingDoc || spouseLast4SSN === customerData.customerLeadData.leadContact.contactLast4SSN}
              onClick={handleGetEmbedURL} 
              className={`w-fit rounded-lg p-3 text-white self-center ${!spouseLast4SSN || spouseLast4SSN.length < 4 || !spouseName || gettingDoc || spouseLast4SSN === customerData.customerLeadData.leadContact.contactLast4SSN ? 'bg-gray-400 cursor-not-allowed' : 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200'}`}>
              Get Started
            </button>
            {gettingDoc && (
              <div className='flex flex-row items-center justify-center gap-2'>
                <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
                <p>Sending Information...</p>
              </div>
            )}
            {error && (
              <p className='text-center text-red-500'>{error}</p>
            )}
          </div>
        </div>
      ) : (
        <div className='w-full flex flex-col items-center justify-center gap-4'>
          <p className='text-2xl font-bold'>Spouse Affidavit Signature</p>
          {embedUrl ? (
            <div className='w-full h-full flex flex-1 flex-col items-center gap-4'>
              <div className='lg:w-1/2 w-11/12 h-[70vh]' id='iframe-container'></div>
            </div>
          ) : (
            <div className='flex flex-row items-center justify-center gap-2'>
              <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
              <p>Loading...</p>
            </div>
          )}
        </div>
      )}
    </div>
  )
}